import { createAPIMutationHook } from '@medizzy/api';
import { createCheckoutSession } from '../methods/create-checkout-session.ts';

export const useCreateCheckoutSession = createAPIMutationHook({
  mutationFn: createCheckoutSession,
});
